import { Controller } from "react-hook-form";
import { Input } from "../input";

export default function PercentageInput({ name, control }: any) {
  return (
    <div className="flex-1">
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <div className="relative w-full">
            <Input
              type="number"
              inputMode="numeric"
              min={50}
              max={100}
              step={1}
              placeholder="Enter percentage"
              value={field.value ?? ""}
              onChange={(e) => {
                let value = Number(e.target.value);

                if (Number.isNaN(value)) return;

                // 🔒 Clamp between 0 and 100
                if (value < 0) value = 50;
                if (value > 100) value = 100;

                field.onChange(value);
              }}
              className="
w-full bg-[#fcfcfc] border-[#cdd1d0]
h-10 rounded-xl pl-3 pr-8 py-2 text-sm
"
            />

            {/* % Suffix */}
            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#697571] text-sm">
              %
            </span>
          </div>
        )}
      />
    </div>
  );
}
